import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutDashboard: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="layout-dashboard, grid, window"><path d="M3 3.75C3 3.33579 3.33579 3 3.75 3H11.25V9H3V3.75Z" fill="currentColor"/><path d="M3 10.5V20.25C3 20.6642 3.33579 21 3.75 21L11.25 21V10.5H3Z" fill="currentColor"/><path d="M12.75 21L20.25 21C20.6642 21 21 20.6642 21 20.25V15H12.75V21Z" fill="currentColor"/><path d="M21 13.5V3.75C21 3.33579 20.6642 3 20.25 3H12.75V13.5H21Z" fill="currentColor"/></CentralIconBase>;
};

export default IconLayoutDashboard;
